<template>
  <snt-loading
    :loading="$apollo.loading"
    content-class="pa-3"
    min-height="150px">
    <PeakForm
      v-if="!setting.peakAccountConnected" />
    <PeakLogout v-else />
  </snt-loading>
</template>

<script>
import { GET_SETTING_PEAK } from '@/resources/graphql'
import PeakForm from './PeakForm.vue'
import PeakLogout from './PeakLogout.vue'

export default {
  components: {
    PeakForm,
    PeakLogout
  },
  apollo: {
    setting: {
      query: GET_SETTING_PEAK
    }
  },
  data () {
    return {
      setting: {
        peakAccountConnected: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
